{
  "next": "Næste",
  "previous": "Forrige"
}
